import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Controller, useFormContext } from 'react-hook-form';
import { Box } from '@xstyled/styled-components';
import Checkbox from '@/UI/Form/Checkbox';
import { FlexBox } from '@/UI/Primitives/FlexBox';

export default function FilterItem({ label, name, qty, subItem }) {
  const router = useRouter();

  const { control } = useFormContext();
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    let categories = [];

    if (router.query?.kategooria?.includes(name)) {
      categories.push(name);
      setSelected(categories);
    }

    const handleRouteChange = () => setSelected([]);

    router.events.on('routeChangeStart', handleRouteChange);
  }, [router.query]);

  return (
    <FlexBox
      justify="space-between"
      align="center"
      w={240}
      lineHeight={2}
      pl={subItem && '1.75rem'}
      fontWeight={selected?.includes(name) ? 700 : 400}
    >
      <Controller
        name={name}
        control={control}
        defaultValue={false}
        render={({ field }) => (
          <Checkbox
            {...field}
            label={label}
            hideBox
            padding={subItem && 0}
            fontSize={subItem && 'xxsmall'}
            color={subItem && 'blue-200'}
            cursor="pointer"
          />
        )}
      />
      {qty && (
        <Box
          as="span"
          pl="0.5rem"
          color="lightgray"
          fontSize={subItem && 'xxsmall'}
        >
          {qty}
        </Box>
      )}
    </FlexBox>
  );
}
